/*global mod*/

mod.modules.define("CompanyNews", "BaseModule", function(fn) {

	var minHeight = 600;

	fn.prototype.init = function(params) {
		this.base("init", params);

		// Add the page if it's necessary
		if (this.el.find("div.pager-wrap").length) {
			this.addPlugin("Plugin-Paging");
		}

		this.limitContentSize();
		this.matchColumnHeight();
	};

	fn.prototype.limitContentSize = function() {
		var $content = this.el.find("ul.companynews-newslist a span.text-bold");

		if ($content.length) {
			// Shrink the titles down if necessary
			$content.dotdotdot({
				height : 35,
				tolerance: 0,
				wrap: 'letter'
			});
		}
	};

	fn.prototype.matchColumnHeight = function() {
		var col1 = this.el.find("div.column-1");
		var col2 = this.el.find("div.column-2");

		if (col1.length && col2.length) {
			var col1Height = col1.height();
			var newHeight = Math.max(col1Height, minHeight);

			// Don't allow the height to be larger than the module
			newHeight = Math.min(this.el.find("div.module-content").height() - 10, newHeight);

			col2.height(newHeight);
		}
	};

	fn.prototype.events = {
		"a[data-documentkey]:not(.module-expand-link)": {
			"click": function(e, $el) {
				this.reload({
					ActiveDocumentKey: $el.attr("data-documentkey")
				});
			}
		}
	};

});